import { useSiesta } from '../SiestaProvider';
import { ConversationListItem } from './types';

/** Both params go together on a member's page: the backend reads them as household plus member. */
export function useHistoryScope() {
  const { chatScope } = useSiesta();
  const clientId = chatScope.clientId ?? chatScope.focusedClientId ?? undefined;
  const familyId = chatScope.familyId ?? undefined;
  const viewedFamilyId = clientId ? undefined : familyId;

  const showsLabel = (conversation: ConversationListItem) => {
    const isViewedClient = conversation.clientId !== null && conversation.clientId === clientId;
    const isViewedFamily =
      conversation.familyId !== null && conversation.familyId === viewedFamilyId;
    return !isViewedClient && !isViewedFamily;
  };

  return { clientId, familyId, showsLabel };
}
